import React from "react";
import { Loading } from "./app/components";
import { MainApp } from "./app/containers";

function App() {
  return (
    <React.Fragment>
      <React.Suspense fallback={<Loading />}>
        <MainApp />
      </React.Suspense>
    </React.Fragment>
  );
}

export default App;
